import React from 'react';
import { Target, CheckCircle2 } from 'lucide-react';

export function StatutoryGoals() {
  const goals = [
    'Ekologia, ochrona zwierząt udomowionych i dziko żyjących, ochrona dziedzictwa przyrodniczego',
    'Wspieranie wszelkich działań mających na celu zapobieganie i zwalczanie bezdomności zwierząt',
    'Przeciwdziałanie wszelkim formom stosowania przemocy i okrucieństwa wobec zwierząt',
    'Udzielanie pomocy zwierzętom krzywdzonym, porzuconym oraz zagubionym',
    'Propagowanie idei ochrony praw zwierząt w społeczeństwie',
    'Propagowanie idei odpowiedzialnego gospodarowania odpadami komunalnymi',
    'Propagowanie idei troski o środowisko naturalne'
  ];

  const activities = [
    {
      title: 'Działalność odpłatna',
      code: '96.09.Z',
      items: [
        'Ochrona zwierząt udomowionych i dziko żyjących',
        'Udzielanie pomocy zwierzętom krzywdzonym, porzuconym oraz zagubionym',
        'Organizowanie pomocy medycznej oraz realizowanie programu kastracji i sterylizacji zwierząt',
        'Wspieranie działań mających na celu zapobieganie i zwalczanie bezdomności zwierząt',
        'Poszukiwanie domów docelowych i tymczasowych dla bezdomnych zwierząt',
        'Działalność adopcyjna'
      ]
    },
    {
      title: 'Działalność nieodpłatna',
      code: '94.99.Z',
      items: [
        'Współpraca z wolontariuszami i ich szkolenia',
        'Współpraca z innymi organizacjami wspierającymi ochronę zwierząt',
        'Współpraca z instytucjami państwowymi i samorządowymi',
        'Współdziałanie z właściwymi instytucjami w zakresie ścigania przestępstw wobec zwierząt',
        'Współpraca z jednostkami oświatowymi',
        'Organizowanie akcji edukacyjnych i propagandowych',
        'Rozpowszechnianie wiedzy o ochronie praw zwierząt',
        'Występowanie z inicjatywą w zakresie zmian przepisów dotyczących praw zwierząt',
        'Prowadzenie punktów informacyjnych fundacji'
      ]
    }
  ];

  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <Target className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Cele statutowe
        </h2>
      </div>

      <div className="space-y-8">
        {/* Goals */}
        <div className="space-y-4">
          <h3 className="heading-4 mb-4">
            Cele działania
          </h3>
          <div className="space-y-3">
            {goals.map((goal, index) => (
              <div key={index} className="list-item">
                <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" aria-hidden="true" />
                <p className="body-medium no-margin">
                  {goal}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Activities */}
        <div className="space-y-6">
          <h3 className="heading-4">
            Realizacja celów
          </h3>
          
          {activities.map((activity, index) => (
            <div key={index} className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
              <h4 className="heading-5 mb-4">
                {activity.title}
              </h4>
              <div className="space-y-3">
                {activity.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="list-item">
                    <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
                    <p className="body-medium no-margin">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}